import {
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../../../components/ConfirmationDialog/styles';
import { AlertTypography } from '../../../components/UI/Typography';
import { Constants } from '../../../constants/entrance';

interface EntranceConfirmationDialogProps {
  referenceNumber: number;
  open: boolean;
  handleClose: () => void;
  modalCallback: () => void;
}

export default function EntranceConfirmationDialog({
  referenceNumber,
  open,
  handleClose,
  modalCallback,
}: EntranceConfirmationDialogProps): JSX.Element {
  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="Entrance confirmation dialog"
    >
      <DialogContainer>
        <TextTypography>
          {Constants.changeStatus.replace('**', `${referenceNumber}`)}
        </TextTypography>
        <ButtonBox>
          <OutlinedButton onClick={handleClose}>{Constants.no}</OutlinedButton>
          <FilledButton onClick={handleConfirm} form="entrance" type="submit">
            {Constants.yes}
          </FilledButton>
        </ButtonBox>
        <AlertTypography>{Constants.confirmationAlert}</AlertTypography>
      </DialogContainer>
    </StyledDialog>
  );
}
